const mobileRegex = /^3\d{8,9}$/; // Esempio: 320xxxxxxx o 345xxxxxxx
const fixedLineRegex = /^(0\d{1,3})\d{6,10}$/; // Esempio: 02xxxxxxx o 081xxxxxxx

export const checkIsTelephone = (value: string): boolean => {
  // Rimuovi spazi, trattini o caratteri speciali
  const cleanNumber = value.replace(/\D/g, '');
  return mobileRegex.test(cleanNumber);
};
